<template>
    <figure class="image is-1by1" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
        <div onclick="window.open('https://bagisto.com', '_blank')" class="pointer-hand">
            <img src="/img/referenzen-bagisto.png" alt="Bagisto">
        </div>
    </figure>
</template>

<script>
    export default {
        name: 'Referenzen-Kunden-4',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
